import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/seattle-area-contractors")({
  beforeLoad: () => {
    throw redirect({ to: "/king-county-contractors", replace: true, statusCode: 301 });
  },
});
